function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { StyleSheet, Text, Image, TouchableOpacity, View, TextInput, ScrollView, TouchableWithoutFeedback, Button, Platform
// Customizable Area Start
// Customizable Area End
} from "react-native";
import GraphicalChartsController, { configJSON } from "./GraphicalChartsController";
export default class GraphicalCharts extends GraphicalChartsController {
  constructor(props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    return (
      /*#__PURE__*/
      // Customizable Area Start
      React.createElement(ScrollView, {
        keyboardShouldPersistTaps: "always",
        style: styles.container
      }, /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
        onPress: () => {
          this.hideKeyboard();
        }
      }, /*#__PURE__*/React.createElement(View, null, this.isPlatformWeb() ? /*#__PURE__*/React.createElement(Text, {
        testID: "labelTitle" //Merge Engine::From BDS
        ,
        style: styles.title //UI Engine::From Sketch
      }, configJSON.labelTitleText) //UI Engine::From Sketch
      : null, /*#__PURE__*/React.createElement(Text, {
        testID: "labelBody" //Merge Engine::From BDS
        ,
        style: styles.body //UI Engine::From Sketch
      }, " ", configJSON.labelBodyText, " "), /*#__PURE__*/React.createElement(Text, {
        testID: "txtSaved"
      }, "This is the reviced value:", this.state.txtSavedValue, " "), /*#__PURE__*/React.createElement(View, {
        style: styles.bgPasswordContainer
      }, /*#__PURE__*/React.createElement(TextInput, _extends({
        testID: "txtInput" //Merge Engine::From BDS
        ,
        style: styles.bgMobileInput //UI Engine::From Sketch
        ,
        placeholder: configJSON.txtInputPlaceholder //UI Engine::From Sketch
      }, this.txtInputProps)), /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
        testID: "btnShowHide" //Merge Engine::From BDS
        ,
        style: styles.showHide //UI Engine::From Sketch
      }, this.btnShowHideProps), /*#__PURE__*/React.createElement(Image, _extends({
        testID: "btnShowHideImage" //Merge Engine::From BDS - testIDImage
        ,
        style: styles.imgShowhide //UI Engine::From Sketch
      }, this.btnShowHideImageProps)))), /*#__PURE__*/React.createElement(Button, _extends({
        testID: "btnExample" //Merge Engine::From BDS
        ,
        title: configJSON.btnExampleTitle //UI Engine::From Sketch
      }, this.btnExampleProps)))))
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    marginLeft: "auto",
    marginRight: "auto",
    width: Platform.OS === "web" ? "75%" : "100%",
    maxWidth: 650,
    backgroundColor: "#ffffffff"
  },
  title: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  body: {
    marginBottom: 32,
    fontSize: 16,
    textAlign: "left",
    marginVertical: 8
  },
  bgPasswordContainer: {
    flexDirection: "row",
    backgroundColor: "#00000000",
    marginBottom: 16,
    borderBottomWidth: 1,
    borderColor: "#767676",
    borderRadius: 2,
    padding: 10,
    borderWidth: Platform.OS === "web" ? 0 : 1
  },
  bgMobileInput: {
    flex: 1
  },
  showHide: {
    alignSelf: "center"
  },
  imgShowhide: Platform.OS === "web" ? {
    height: 30,
    width: 30
  } : {}
});
// Customizable Area End